import React from "react";
import HeroCarouselV2 from "./v2/HeroCarouselV2";
import HeroSectionV2 from "./v2/HeroSectionV2";
import PromoCardV2 from "./v2/PromoCardV2";
import { HomeBanner } from "@/packages/types/banner";
import { HomePageSectionData } from "@/api-service/homePage";

type SliderWithPromotionalProps = {
  section?: HomePageSectionData;
  className?: string;
};

const SliderWithOnePromo: React.FC<SliderWithPromotionalProps> = ({ section }) => {
  if (!section || !section.sliders || section.sliders.length === 0) {
    return null;
  }

  const banners: HomeBanner[] = section.sliders.map((s) => ({
    id: s.id,
    fileName: s.fileName || "",
    mobileFileName: s.mobileFileName || "",
    imageUrl: s.imageUrl || "",
    mobileUrl: s.mobileUrl || "",
    navigationLink: s.navigationLink || "",
  }));

  const promoBanner: HomeBanner | null = section.promoCard
    ? {
        id: section.promoCard.id,
        fileName: section.promoCard.fileName || "",
        mobileFileName: section.promoCard.mobileFileName || "",
        imageUrl: section.promoCard.imageUrl || "",
        mobileUrl: section.promoCard.mobileUrl || "",
        navigationLink: section.promoCard.navigationLink || "",
      }
    : null;

  return (
    <HeroSectionV2
      carousel={<HeroCarouselV2 banners={banners} className="w-full h-full" />}
      promoComponent={
        <PromoCardV2
          imageUrl={promoBanner?.imageUrl || "/assets/site/images/default.png"}
          mobileUrl={promoBanner?.mobileUrl}
          navigationLink={promoBanner?.navigationLink || ""}
          className="w-full h-full"
        />
      }
    />
  );
};

export default SliderWithOnePromo;


